<template>
  <div class="user-layout-box">
    <top-menu></top-menu>
    <div class="user-layout-sub-box">
      <router-view/>
    </div>
  </div>
</template>

<script>
import TopMenu from '@/views/components/TopMenu';
export default {
  name: 'UserLayout',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    TopMenu,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.$store.commit('loginInfo/set_login_type', 'user');
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.user-layout-box {
  .user-layout-sub-box {
    padding: 20px;
    margin: 50px 0 0 0;
  }
  @media (max-width: 767px) {
    .user-layout-sub-box {
      padding: 10px;
    }
  }
}
</style>
